<template>
  <article>
    <Masthead />
    <ManageSection />
    <SeenOn />
    <ProfilesSection />
    <ProSection />
    <OrgSection />
    <RaisedCtaSection
      title="Simplify your link in bio management today"
      text="Start taking your link in bio seriously, with a professional looking Campsite.bio profile."
    >
      <Button
        href="https://app.campsite.bio/create-account"
        variant="hard-shadow"
        size="large"
        >Get started</Button
      >
    </RaisedCtaSection>
  </article>
</template>

<script>
import { Button } from '@campsite-bio/component-lib';

import { generateMeta } from '@/utils/generate-meta';
import Masthead from '@/components/home/masthead/masthead';
import ProfilesSection from '@/components/home/profiles-section/profiles-section';
import ProSection from '@/components/home/pro-section/pro-section';
import OrgSection from '@/components/home/org-section/org-section';
import SeenOn from '@/components/seen-on-default';
import ManageSection from '@/components/home/manage-section/manage-section';
import RaisedCtaSection from '@/components/sections/raised-cta-section';

export default {
  name: 'Home',

  head() {
    return generateMeta({
      title:
        'Campsite.bio - A Link in Bio tool for Instagram, TikTok, and more',
      description:
        'A link in bio tool created just for you. Use our free landing page tool to create your own space on the web. Turn your followers into conversions.',
    });
  },

  components: {
    Button,
    Masthead,
    ProfilesSection,
    ProSection,
    OrgSection,
    SeenOn,
    ManageSection,
    RaisedCtaSection,
  },
};
</script>

<style lang="scss"></style>
